export default __webpack_public_path__ + "static/media/redes.181674e5.png";